import React from 'react'
import clsx from 'clsx'

import './index.scss'

export interface Option {
    value: string
    label: string
    id: number
    description?: string
}

interface RadioProps {
    options: Option[]
    title?: string
    field: any
    defaultCheckedId?: number
    onChange?: (value: Option) => void
    disabled?: boolean
    direction?: 'row' | 'column'
}

const Radio = ({ field, title, options, defaultCheckedId, onChange, disabled, direction }: RadioProps) => {
    const changeHandler = (item: Option) => {
        onChange && onChange(item)
    }

    return (
        <div className={clsx('radio', disabled && 'disabled', direction)}>
            {title && <div className="radio__title">{title}</div>}
            {options.map((item: Option) => (
                <div key={item.value} className="radio__item">
                    <div className="radio__item-title">
                        <input
                            className="radio__input"
                            type="radio"
                            id={item.id.toString()}
                            name={field && field.name}
                            value=""
                            onChange={() => {
                                changeHandler(item)
                            }}
                            defaultChecked={!!(defaultCheckedId && defaultCheckedId === item.id)}
                        />
                        <label htmlFor={item.id.toString()} className="radio__label">
                            {item.label}
                        </label>
                    </div>
                    {item.description ? <p className="radio__item-description">{item.description}</p> : null}
                </div>
            ))}
        </div>
    )
}

export default Radio
